import {
  RelevanceValue,
  SearchResult,
} from '@twiliointernal/e2-commons-shared-definitions';

export interface SupportSearchProps {
  variant: SupportSearchVariant;
}

export enum SupportSearchVariant {
  withIllustration = 'withIllustration',
  withOutIllustration = 'withOutIllustration',
}
export interface FeedbackArgs {
  queryId: string;
  resultId: string;
  relevanceValue?: RelevanceValue;
  clickTime?: number;
}

export interface ResultProps extends SearchResult {
  index: number;
  isRecommended: boolean;
  onUserFeedback: (args: FeedbackArgs) => void;
  searchValue: string;
}

export interface SearchResultsProps {
  onUserFeedback: (args: FeedbackArgs) => void;
  searchResults: SearchResult[];
  searchValue: string;
}

export interface RenderWelcomeBannerProps {
  articleId: string;
  heading: string;
  label: string;
}
